var map = {
	"./YLLKSA/background.svg": 441,
	"./YLLKSA/gallary/DSC09640.png": 457,
	"./YLLKSA/gallary/DSC09685.png": 458,
	"./YLLKSA/gallary/DSC09717.png": 459,
	"./YLLKSA/gallary/DSC09731.png": 460,
	"./advertising/mobileapp/banner.png": 830,
	"./advertising/mobileapp/mobile-banner.png": 831,
	"./advertising/reports/banner.png": 832,
	"./advertising/reports/reportbanner2025.png": 433,
	"./ai/ai-vector.png": 461,
	"./ai/ai_logo_h.png": 833,
	"./ai/message.svg": 834,
	"./ai_logo.png": 835,
	"./ai_logo_h.png": 442,
	"./background.png": 836,
	"./background.svg": 358,
	"./basic_logo.png": 837,
	"./basic_logo.svg": 838,
	"./landing/background.png": 839,
	"./landing/features/docs.svg": 840,
	"./landing/features/lib.svg": 841,
	"./landing/features/order.svg": 842,
	"./landing/features/subjects.svg": 843,
	"./landing/features/systems.svg": 844,
	"./landing/footer-background.png": 462,
	"./landing/logo.svg": 845,
	"./logo_bg.svg": 846,
	"./logo_large.svg": 847,
	"./logo_no_text.svg": 848,
	"./maroof.png": 849,
	"./onboarding/security.gif": 463,
	"./payment/mada.svg": 850,
	"./payment/master.svg": 851,
	"./payment/visa.svg": 852,
	"./search.png": 853,
	"./tryagent/bg-ai-stars-mobile.png": 854,
	"./tryagent/bg-ai-stars-mobile.webp": 464,
	"./tryagent/bg-ai-stars.png": 855,
	"./tryagent/bg-ai-stars.webp": 465,
	"./tryagent/tryagent-01.png": 856,
	"./tryagent/tryagent-01.webp": 443,
	"./tryenglish/ellipse6.svg": 444,
	"./tryenglish/tryenglish-01.png": 466,
	"./tryenglish/tryenglish-02.png": 467,
	"./vat.png": 308,
	"./vat_certificate.png": 309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 829;